interface Props {
  anonymized: boolean;
}

export default function AnonymizationBadge({ anonymized }: Props) {
  if (!anonymized) return null;
  return (
    <span
      className="inline-block px-1.5 py-0.5 text-[10px] rounded bg-yellow-900/40 text-yellow-300 border border-yellow-700/50"
      title="Op #12: Langfuse-Trace-Inhalt anonymisiert (>120d). Cost-Record selbst bleibt Audit-Pflicht."
    >
      anon
    </span>
  );
}
